var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DownArrow",
    transform: "translate(24 24) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Back_Arrow",
    "data-name": "Back Arrow",
    transform: "translate(24) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2378",
    "data-name": "Rectangle 2378",
    width: 24,
    height: 24,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7256",
    "data-name": "Path 7256",
    d: "M3.151,0,0,3.149,3.151,6.3",
    transform: "translate(10.654 8.699)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.b1b1575c5c9f8e88fbb1962e50a8986e.svg";
export { ForwardRef as ReactComponent };